import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App'
// Meta Pixel
;
(function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
  if (f.fbq) return;
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e);
  t.async = true;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
(window as any).fbq('init', '1622535445728012');
(window as any).fbq('track', 'PageView');
// SEO & Open Graph meta tags
const setMeta = (property: string, content: string, isName = false) => {
  const attr = isName ? 'name' : 'property';
  let el = document.querySelector(`meta[${attr}="${property}"]`) as HTMLMetaElement;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};
document.title = 'Reset Metabólico 7 Días — Elimina la Inflamación y Recupera tu Cintura';
setMeta('og:title', 'Reset Metabólico 7 Días — Sin Dietas, Sin Hambre');
setMeta('og:description', 'El protocolo de 7 días para mujeres de +40 que quieren apagar la inflamación, recuperar su energía y volver a sentirse ligeras. Acceso inmediato por $6.36.');
setMeta('og:type', 'website');
setMeta('og:image', 'https://cdn.magicpatterns.com/uploads/kf3Aijir3bQeSCoh52kfNb/heylloyd-image-1771657867840.png');
setMeta('og:image:width', '1200');
setMeta('og:image:height', '630');
setMeta('og:locale', 'es_US');
setMeta('og:site_name', 'Reset Metabólico');
setMeta('twitter:card', 'summary_large_image', true);
setMeta('twitter:title', 'Reset Metabólico 7 Días — Sin Dietas, Sin Hambre', true);
setMeta('twitter:description', 'El protocolo de 7 días para mujeres de +40. Elimina la inflamación y recupera tu cintura sin pasar hambre.', true);
setMeta('twitter:image', 'https://cdn.magicpatterns.com/uploads/kf3Aijir3bQeSCoh52kfNb/heylloyd-image-1771657867840.png', true);
setMeta('description', 'El protocolo de 7 días para mujeres de +40 que quieren eliminar la inflamación, recuperar su energía y volver a sentirse ligeras. Sin dietas extremas.', true);
render(<App data-id="element-305" />, document.getElementById('root'));